import { mixpanelTrack } from '@/app/hooks/useAnalytics/mixpanel-track';
import { MixpanelEvent } from '@/app/hooks/useAnalytics/types';
import { envs } from '@/app/utils/envs';

type PushProjectDetailSharedEventParams = {
  areStatisticsCookiesAllowed: boolean;
  userId?: string;
};

export const pushInstagramShareOpenEvent = ({
  areStatisticsCookiesAllowed,
  userId,
}: PushProjectDetailSharedEventParams) => {
  if (!areStatisticsCookiesAllowed) {
    if (envs.isAnalyticInDebugMode) {
      console.log('Skipping InstagramShareOpenEvent, because statistics cookies are not allowed');
    }
    return;
  }

  mixpanelTrack(MixpanelEvent.ButtonClicked, {
    type: 'instagram_share_opened',
    $user_id: userId,
  });
};
